import React from 'react';
import { Container } from 'react-bootstrap-5';
import PageHeaderHeading from './page_header_heading';
import PageHeaderActions from './page_header_actions';
import PageHeaderCount from './page_header_count';
import PageHeaderSubheader from './page_header_subheader';
import classNames from 'classnames';

interface Props {
  children?: React.ReactNode;
  containerWidth?: boolean;
}

export default function PageHeader({ children, containerWidth = false }: Props) {
  const childArray = React.Children.toArray(children);
  const subheader = childArray.find(
    child => React.isValidElement(child) && child.type === PageHeaderSubheader
  );
  const mainChildren = childArray.filter(
    child => !(React.isValidElement(child) && child.type === PageHeaderSubheader)
  );

  if (containerWidth) {
    return (
      <div className="bg-white border-bottom shadow">
        <div className={classNames('p-4', { 'border-bottom': subheader })}>
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              {mainChildren}
            </div>
          </Container>
        </div>
        {subheader && (
          <div className="px-4">
            <Container>
              <div className="d-flex justify-content-between align-items-center">
                {subheader}
              </div>
            </Container>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="bg-white border-bottom shadow">
      <div className={classNames('p-4', { 'border-bottom': subheader })}>
        <div className="d-flex justify-content-between align-items-center">
          {mainChildren}
        </div>
      </div>
      {subheader && (
        <div className="px-4">
          <div className="d-flex justify-content-between align-items-center">
            {subheader}
          </div>
        </div>
      )}
    </div>
  );
}

PageHeader.Heading = PageHeaderHeading;
PageHeader.Actions = PageHeaderActions;
PageHeader.Count = PageHeaderCount;
PageHeader.Subheader = PageHeaderSubheader;
